export enum DemoStep {
  PLAYING = "PLAYING",
  LEAVING = "LEAVING",
  DONE = "DONE"
}

export default { DemoStep };
